'use client';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ParticleCanvas from '@/app/home/components/ParticleCanvas';

export default function LeaderboardsPage() {
  return (
    <>
      {/* Fixed canvas particle background */}
      <ParticleCanvas />

      {/* Vignette overlay */}
      <div className="vignette" aria-hidden="true" />

      {/* Navigation */}
      <Header />

      {/* Main content */}
      <main className="relative min-h-screen flex items-center justify-center" style={{ zIndex: 2 }}>
        <div className="text-center px-6 py-32">
          <h1 className="text-6xl md:text-8xl font-heading font-800 tracking-[0.12em] mb-6">
            <span className="text-white">COMING </span>
            <span className="bg-gradient-to-r from-[#6a5cff] via-[#8b7fff] to-[#6a5cff] bg-clip-text text-transparent">
              SOON!
            </span>
          </h1>
          <p className="text-vanta-muted text-lg md:text-xl max-w-2xl mx-auto">
            Leaderboards are under development. Check back soon to see the top players!
          </p>
        </div>
      </main>

      <Footer />
    </>
  );
}